module.exports = __webpack_public_path__ + "static/STG20_Mobile_480_Module5_Drink4_Rita-b9c1dd1d1a2305b7bb7ac3eabde55380.png";